export class CostPlanExport {
  development: string;
  name: string;
  status: string;
  wbsProjectBudget: string | null;
  fileName: string;
  message: string;

  constructor(
    development: string,
    name: string,
    status: string,
    wbsProjectBudget: string,
    fileName: string,
    message: string
  ) {
    this.development = development;
    this.name = name;
    this.status = status;
    this.wbsProjectBudget = wbsProjectBudget;
    this.message = message;
    this.fileName = fileName;
  }

  public static getDefault(): CostPlanExport {
    return new CostPlanExport("", "", "", "", "", "");
  }
}



// WEBPACK FOOTER //
// ./src/modules/costPlan/models/CostPlanExport.tsx